import Footer from "../components/Footer";
import Header from "../components/Header";

export default function Editorial() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow h-full place-items-center px-5 sm:px-96 mb-40">
        <div className=" font-bold text-xl">EDITORIAL BOARD</div>
        <div className=" sm:w-9/12  mt-10">
          <div className="">
            <div className="font-semibold">Chief Editor</div>
            <div className="font-semibold mt-4">Prof. James L T Thanga</div>
            <div className="">
              Department of Economics, Mizoram University, Aizawl,
              Mizoram-796004
            </div>
            <div className="flex flex-row">
              <a
                href="mailto:jametea@yahoo.com"
                className="hover:text-indigo-500"
              >
                jametea@yahoo.com /
              </a>
              <a
                href="mailto:jametea@mzu.edu.in"
                className="hover:text-indigo-500 pl-2"
              >
                jametea@mzu.edu.in
              </a>
            </div>
          </div>
          <div className="mt-10">
            <div className="font-semibold">Joint Editors</div>
            <div className="mt-5">
              <div className="font-semibold">1. Dr. Lalchhuanmawia</div>
              <div className="">
                Govt. T. Romana College, Aizawl, Mizoram-796005
              </div>
              <div className="flex flex-row">
                <a
                  href="mailto:mawitea@trcollege.edu.in"
                  className="hover:text-indigo-500"
                >
                  mawitea@trcollege.edu.in
                </a>
              </div>
            </div>
            <div className="mt-2">
              <div className="font-semibold">2. Samuel J. Laltlanzaua</div>
              <div className="">
                Govt. Johnson College, Aizawl, Mizoram-796001
              </div>
              <div className="flex flex-row">
                <a
                  href="mailto:samuel@jtc.edu.in"
                  className="hover:text-indigo-500"
                >
                  samuel@jtc.edu.in
                </a>
              </div>
            </div>
            <div className="mt-2">
              <div className="font-semibold">3. Dr. Rohmingliani</div>
              <div className="">
                Govt. Hrangbana Colege, Aizawl, Mizoram – 796007
              </div>
              <div className="flex flex-row">
                <a
                  href="mailto:jessie@ghbc.edu.in"
                  className="hover:text-indigo-500"
                >
                  jessie@ghbc.edu.in
                </a>
              </div>
            </div>
            <div className="mt-2">
              <div className="font-semibold">4. Dr. Joseph Lalremsanga</div>
              <div className="">Ramhlun North, Aizawl, Mizoram – 796012</div>
              <div className="flex flex-row">
                <a
                  href="mailto:joseph@iumizoram.edu.in"
                  className="hover:text-indigo-500"
                >
                  joseph@iumizoram.edu.in
                </a>
              </div>
            </div>
          </div>
          <div className="mt-10">
            <div className="font-semibold">Managing Editor & Publisher</div>
            <div className="font-semibold mt-4">Dr. Lalchhuanmawia</div>
            <div className="">
              Govt. T. Romana College, Aizawl, Mizoram-796005
            </div>
            <div className="flex flex-row">
              <a
                href="mailto:mawitea@trcollege.edu.in"
                className="hover:text-indigo-500"
              >
                mawitea@trcollege.edu.in
              </a>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
